import { render, staticRenderFns } from "./ChangeStorageType.vue?vue&type=template&id=15957139"
import script from "./ChangeStorageType.vue?vue&type=script&lang=js"
export * from "./ChangeStorageType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports